import { moveItemInArray } from '@angular/cdk/drag-drop';
import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { map, tap } from 'rxjs';
import { AccountingService } from '../accounting.service';
import { AddCategory, LoadCategories, LoadTransactions, OrderCategory, UpdateSelection } from './accounting.actions';

export interface AccountingStateModel {
  transactions: string[]
  categories: any[]
  selection: any[]
}

const defaults: AccountingStateModel = {
  transactions: [],
  selection: [],
  categories: [],
};

@State<AccountingStateModel>({
  name: 'accounting',
  defaults
})
@Injectable()
export class AccountingState {

  constructor(
    private accounting: AccountingService
  ) { }

  @Action(LoadCategories)
  loadCategories({ getState, patchState }: StateContext<AccountingStateModel>) {
    const state = getState();
    return this.accounting.getCategories().pipe(
      map((categories: any[]) => {
        patchState({ categories })
      })
    );
  }

  @Action(AddCategory)
  addCategory({ getState, patchState }: StateContext<AccountingStateModel>, { category }: AddCategory) {
    return this.accounting.addCategory({name: category}).pipe(
      tap((category => {
        const categories = getState().categories;

        categories.push(category);

        patchState({ categories: [...categories] })
      }))
    )
  }

  @Action(UpdateSelection)
  updateSelection({ patchState }: StateContext<AccountingStateModel>, { selection }: UpdateSelection) {
    patchState({ selection });
  }

  @Action(LoadTransactions)
  loadTransactions({ getState, patchState }: StateContext<AccountingStateModel>, { }: LoadTransactions) {

    return this.accounting.getAllTransactions(undefined, undefined, 10000).pipe(
      tap((transactions: any) => {
        patchState({ transactions })
      })
    );
    // const state = getState();
    // setState({ items: [...state.items, payload] });
  }

  @Action(OrderCategory)
  orderCategory({ getState, patchState }: StateContext<AccountingStateModel>, { category, previousIndex, currentIndex }: OrderCategory) {
    const { categories } = getState();

    moveItemInArray(categories, previousIndex, currentIndex);

    patchState({ categories: [...categories] })
  }


  @Selector()
  static categories(model: AccountingStateModel) {
    return model.categories;
  }

  @Selector([AccountingState])
  static categoriesSlugMap(state: AccountingStateModel) {
    const categories = new Map<string, any>();

    state.categories.forEach(category => {
      categories.set(category.code, category);
    })

    return categories;
  }


  @Selector()
  static transactions(model: AccountingStateModel) {
    return model.transactions;
  }

  @Selector()
  static selection(model: AccountingStateModel) {
    return model.selection;
  }

  @Selector()
  static selectionIds(model: AccountingStateModel) {
    const set = new Set<string>();

    model.selection?.forEach(selection => {
      set.add(selection.id)
    })


    return [...set];
  }


}
